<script>
export default {
    name: "InpatientReportPrint",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchPatients(),]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchPatients() {
            let url = `PatientsReports/GetCurrentInpatientReport?special=${this.$route.query.special}`;
            url += this.$route.query.ward ? `&ward=${this.$route.query.ward}` : ``;
            url += this.$route.query.search ? `&SearchText=${this.$route.query.search}`  : ``;

            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="w-full text-center">
        <h5 class="font-medium">Current Inpatient Report</h5>
    </div>
    <table class="table table-hover" id="currentInpatientReport">
        <thead class="text-xs">
              <tr class="w-full flex">
                  <th class="p-tiny w-1/12">MRN</th>
                  <th class="p-tiny w-1/6">Names</th>
                  <th class="p-tiny w-1/12">IPFile No</th>
                  <th class="p-tiny w-1/12">Gender</th>
                  <th class="p-tiny w-1/6">PMode</th>
                  <th class="p-tiny w-1/12">Admitted By</th>
                  <th class="p-tiny w-1/12">Admitted On</th>
                  <th class="p-tiny w-1/12">Days</th>
                  <th class="p-tiny w-1/12">Ward</th>
                  <th class="p-tiny w-1/12">Bed</th>
              </tr>
        </thead>
        <tbody class="text-xs flex flex-col items-center">
            <tr class="w-full flex" v-for="(patient,idx) in patients" :key="idx">
                <td class="p-tiny w-1/12">{{ patient.patienT_ID }}</td>
                <td class="p-tiny w-1/6">{{ patient.names }}</td>
                <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                <td class="p-tiny w-1/12">{{ patient.gender }}</td>
                <td class="p-tiny w-1/6">{{ patient.pMode }}</td>
                <td class="p-tiny w-1/12">{{ patient.admittedBy }}</td>
                <td class="p-tiny w-1/12">{{ patient.dateAdmitted | dateFormat }}</td>
                <td class="p-tiny w-1/12">{{ patient.days }}</td>
                <td class="p-tiny w-1/12">{{ patient.ward }}</td>
                <td class="p-tiny w-1/12">{{ patient.bed }}</td>
            </tr>
            <tr class="w-full flex">
                <th class="w-1/2 p-tiny"></th>
                <th class="w-1/2 p-tiny text-right">Total Current Inpatients: {{ patients.length }}</th>
            </tr>
        </tbody>
    </table>
</div>
</template>